module.exports = __webpack_public_path__ + "img/960.5f055ca8.svg";